module.exports = __webpack_public_path__ + "static/media/VolEx_logo_footer.f6acd9fe.svg";